import { Modal, Text, Heading, Button, Shortcut } from "mondrian-react"
import { useState } from 'react'
import { logger } from "utils/logger"
import { reportGA4 } from "utils/pushDataLayer";

import "./styles.scss";

export const ShortcutRedirectLogin = ({ redirect, children, loggerName, loggerElement, customTitle, ...props }) => {
    const [isOpen, setIsOpen] = useState(false)

    const showModal = () => {
        setIsOpen(true)
    }

    const closeModal = () => {
        setIsOpen(false)
    }

    const removePrefix = (title) => {
        const prefix = ["facilidades:", "pague_sua_fatura:"].find(p => title.startsWith(p));
        return prefix ? title.replace(prefix, "") : title;
    };

    return (
        <>
            <Shortcut
                onClick={() => {
                    logger({ name: loggerName, element: loggerElement });
                    reportGA4({ customTitle: `${customTitle}` });
                    showModal();
                }}
                {...props}
            >
                {children}
            </Shortcut>
            <Modal
            sm
            className="modalRedirectLogin"
            data={{
                header: <Heading md>{children}</Heading>,
                content: (
                    <>
                        <Text body>
                            Para concluir essa operação, você precisa validar o seu usuário e senha.
                        </Text>
                        <div className="actionButtons">
                            <Button primary href={redirect} onClick={() => {
                                const modifiedTitle = removePrefix(`${customTitle}:efetuar_login`);
                                logger({ name: loggerName, element: `${loggerElement}_EfetuarLogin` });
                                reportGA4({customTitle: modifiedTitle});
                            }}>
                                Efetuar login
                            </Button>
                            <Button secondary onClick={() => {
                                closeModal();
                                const modifiedTitle = removePrefix(`${customTitle}:fechar`);
                                logger({ name: loggerName, element: `${loggerElement}_Fechar` });
                                reportGA4({customTitle: modifiedTitle});
                            }}>
                                Fechar
                            </Button>
                        </div>
                    </>
                ),
                isOpen: isOpen,
                onCloseClick: closeModal
            }}
            />
        </>
    )
}